import { get, post } from '@/api/index';
export const getstudentinfos = params => get(`/api/login/v1/foreuser/getstudentinfos`, params);//  地址列表
export const uploadImg = params => get(`/api/uploader/v1/upload_image`, params); //网页上传图片
export const checklogin = params => post(`/api/login/v1/foreuser/checklogin`, params); //验证登录
export const getname = params => get(`/api/login/v1/getname`, params); //网页上传图片
export const schoolextinfo = params => get(`/api/login/v1/after/schoolext/info`, params); //根据学校id获取学校信息
export const schoolinfo = params => get(`/api/login/v1/after/schoolext/info`, params); //根据学校id获取学校信息
export const toKey = params => get(`/api/login/v1/sessionkey`, params); // 公共获取sid
